/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scene_Description_Job_Submitted_SuccessInputs */

const en_scene_description_job_submitted_success = /** @type {(inputs: Scene_Description_Job_Submitted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shot description job submitted successfully. You can monitor progress in the Shot Description Import Dashboard.`)
};

const fr_scene_description_job_submitted_success = /** @type {(inputs: Scene_Description_Job_Submitted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La description du plan a été soumise avec succès. Vous pouvez suivre sa progression dans le tableau de bord d'importation des descriptions de plan.`)
};

const de_scene_description_job_submitted_success = /** @type {(inputs: Scene_Description_Job_Submitted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Import der Shotbeschreibungen wurde erfolgreich abgeschlossen. Sie können den Fortschritt im Shotbeschreibungs-Import-Dashboard verfolgen.`)
};

const it_scene_description_job_submitted_success = /** @type {(inputs: Scene_Description_Job_Submitted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Richiesta di descrizione dell'inquadratura inviata correttamente. È possibile monitorare l'avanzamento nella dashboard di importazione della descrizione dell'inquadratura.`)
};

const ru_scene_description_job_submitted_success = /** @type {(inputs: Scene_Description_Job_Submitted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Задание по импорту описания кадра успешно отправлено. Вы можете отслеживать ход выполнения на панели управления импортом описания кадра.`)
};

const es_scene_description_job_submitted_success = /** @type {(inputs: Scene_Description_Job_Submitted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La descripción de la toma se ha enviado correctamente. Puede consultar el progreso en el panel de importación de descripciones de tomas.`)
};

const zh_cn2_scene_description_job_submitted_success = /** @type {(inputs: Scene_Description_Job_Submitted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`镜头描述任务已成功提交。您可以在镜头描述导入控制面板中查看进度。`)
};

const ja_scene_description_job_submitted_success = /** @type {(inputs: Scene_Description_Job_Submitted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`撮影内容の説明が正常に送信されました。撮影内容の説明インポートダッシュボードで進捗状況を確認できます。`)
};

const hi_scene_description_job_submitted_success = /** @type {(inputs: Scene_Description_Job_Submitted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शॉट विवरण कार्य सफलतापूर्वक सबमिट हो गया है। आप शॉट विवरण आयात डैशबोर्ड में प्रगति की निगरानी कर सकते हैं।`)
};

const pt_pt2_scene_description_job_submitted_success = /** @type {(inputs: Scene_Description_Job_Submitted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A descrição da cena foi enviada com sucesso. Você pode acompanhar o progresso no Painel de Importação da Descrição da Cena.`)
};

/**
* | output |
* | --- |
* | "Shot description job submitted successfully. You can monitor progress in the Shot Description Import Dashboard." |
*
* @param {Scene_Description_Job_Submitted_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const scene_description_job_submitted_success = /** @type {((inputs?: Scene_Description_Job_Submitted_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Description_Job_Submitted_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_scene_description_job_submitted_success(inputs)
	if (locale === "de") return de_scene_description_job_submitted_success(inputs)
	if (locale === "it") return it_scene_description_job_submitted_success(inputs)
	if (locale === "ru") return ru_scene_description_job_submitted_success(inputs)
	if (locale === "es") return es_scene_description_job_submitted_success(inputs)
	if (locale === "zh-CN") return zh_cn2_scene_description_job_submitted_success(inputs)
	if (locale === "ja") return ja_scene_description_job_submitted_success(inputs)
	if (locale === "hi") return hi_scene_description_job_submitted_success(inputs)
	if (locale === "pt-PT") return pt_pt2_scene_description_job_submitted_success(inputs)
	return en_scene_description_job_submitted_success(inputs)
});